import moment from "moment";
import * as React from "react";
import { RememberJarAPI } from "src/api";

interface IRememberJarListItemProps {
  entry: any;
  onSelectForEditing: any;
  onSelectForDeleting: any;
}

interface IRememberJarListItemState {
  loading: boolean;
}

export default class RememberJarListItem extends React.Component<IRememberJarListItemProps, IRememberJarListItemState> {

  constructor(props: any){
    super(props);
    this.state = {
      loading: false
    };

    this.selectForDeleting = this.selectForDeleting.bind(this);
    this.selectForEditing = this.selectForEditing.bind(this);
  }

  componentDidMount(){
  }

  public render() {
    return (
      <div className="journal-entry-list-item" style={{marginBottom: 10, borderBottom: "thin solid white"}}>
        <div className="row">
          <div className="col-6 col-lg-1 col-md-6">
            {moment(this.props.entry.dateOccurred).format("MM/DD/YY")}
          </div>
          <div className="col-6 col-lg-2 col-md-6">
            {RememberJarAPI.translateType(this.props.entry.rememberType)}
          </div>
          <div className="col-7 col-lg-5 col-md-8">
            {this.props.entry.summary}
          </div>
          <div className="col-6 col-lg-2 col-md-6">
            {RememberJarAPI.translateVisibility(this.props.entry.visibility)}
          </div>
          <div className="col-1 col-lg-1 col-md-1">
            <i className="bi-pencil-fill icon actionable" title="Edit" onClick={this.selectForEditing} />
          </div>
          <div className="col-1 col-lg-1 col-md-1">
            <i className="bi-trash-fill icon actionable" title="Delete" onClick={this.selectForDeleting} />
          </div>
        </div>
      </div>
    );
  }

  private selectForEditing(){
    this.props.onSelectForEditing(this.props.entry);
  }

  private selectForDeleting(){
    this.props.onSelectForDeleting(this.props.entry);
  }

}